import { render, staticRenderFns } from "./symptom-subquestions.vue?vue&type=template&id=508367e0&"
import script from "./symptom-subquestions.vue?vue&type=script&lang=js&"
export * from "./symptom-subquestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports